import React, { JSX } from 'react'
import './index.scss'
import clsx from 'clsx'

export type StatusPillColors = 'yellow' | 'blue' | 'orange' | 'black' | 'green' | 'white' | 'gray'

interface StatusPillPropsText {
    text: string
    color?: StatusPillColors
    tooltip?: never
    big?: boolean
}

interface StatusPillPropsTooltip {
    text?: never
    color?: StatusPillColors
    tooltip: JSX.Element
    big?: boolean
}

type StatusPillProps = StatusPillPropsText | StatusPillPropsTooltip

const StatusPill = ({ text, color, tooltip, big }: StatusPillProps) => (
    <div className={clsx('status', color ?? 'blue', big && 'big')}>
        <span>{tooltip ? tooltip : text}</span>
    </div>
)

export default StatusPill
